"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _warehouse = require("@/api/warehouse");
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _moment = _interopRequireDefault(require("moment"));
var _excluded = ["billNo", "createTime"]; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MallInStorage',
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      col: 6,
      dialogVisible: false,
      editDate: (0, _moment.default)().format('YYYY-MM-DD'),
      rules: {},
      list: [],
      form: {
        bizDate: (0, _moment.default)().format('YYYY-MM-DD'),
        remark: '',
        billNo: '',
        createTime: '',
        inoutId: ''
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    init: function init(info, inoutId) {
      // this.form.date=info.bizDate
      this.form.remark = info.remark;
      this.form.billNo = info.billNo;
      this.form.inoutId = inoutId;
      this.list = info.detailList;
    },
    open: function open(info, inoutId) {
      this.dialogVisible = true;
      this.init(info, inoutId);
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    sure: function sure() {
      var _this = this;
      var newProductList = this.list.map(function (product) {
        return {
          locationId: product.locationId,
          num: product.num,
          productId: product.productId,
          inoutDetailId: product.inoutDetailId
        };
      });
      var _this$form = this.form,
        billNo = _this$form.billNo,
        createTime = _this$form.createTime,
        data = (0, _objectWithoutProperties2.default)(_this$form, _excluded);
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        productLocationList: newProductList
      });
      (0, _warehouse.retEditApi)(params).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this.dialogVisible = false;
          _this.$message.success('操作成功');
        }
      });
    }
  }
};